
export default {
  inheritAttrs: false,
  props: {
    email: {
      type: String,
      default: null
    },
    icon: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    value() {
      return this.email || this.$contact.email
    },
    url() {
      const mail = String(this.value).replace(/\s+/g, '')
      return `mailto:${mail}`
    }
  },
  methods: {
    onClick() {
      this.$tracker.trackEvent('send_email', {
        category: 'contact',
        label: 'email'
      })
    }
  }
}
